import { render, staticRenderFns } from "./importList.vue?vue&type=template&id=2f18cc7e&scoped=true&"
import script from "./importList.vue?vue&type=script&lang=js&"
export * from "./importList.vue?vue&type=script&lang=js&"
import style0 from "./importList.vue?vue&type=style&index=0&id=2f18cc7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f18cc7e",
  null
  
)

export default component.exports